'use client';

/**
 * HomepageV3 EditorialButton — now consumes the published se3 design-system
 * package (`@startengine/design-system.se3.button`, exported as `Se3Button`).
 * This file is a thin re-export adapter so existing local imports keep working.
 *
 * The se3 package is a faithful port: identical props (variant/size/href/
 * disabled/type/onClick/data-cy), identical rendered DOM (`<button>` by
 * default, `<a>` when `href` is provided and not disabled), and identical
 * styling. We re-declare the original prop interface here for type-safety
 * (the package's generated `.d.ts` uses loose `any` types).
 */
import type { FC, MouseEvent, ReactNode } from 'react';
import { Se3Button } from '@startengine/design-system.se3.button';

export type EditorialButtonVariant = 'solid' | 'ghost';
export type EditorialButtonSize = 'sm' | 'md';

export interface EditorialButtonProps {
  variant?: EditorialButtonVariant;
  size?: EditorialButtonSize;
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  href?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  'data-cy'?: string;
}

const EditorialButton = Se3Button as unknown as FC<EditorialButtonProps>;

export default EditorialButton;
